export function createFileSrcSnapshot (files = []) {
  return (files || []).map(file => (file && file.src) || '')
}

export function isAnnotationFileSrcOnlyChange (files = [], previousSrcs = []) {
  if (!Array.isArray(files) || !Array.isArray(previousSrcs)) return false
  if (files.length !== previousSrcs.length) return false

  let changedCount = 0

  for (let i = 0; i < files.length; i++) {
    const oldSrc = previousSrcs[i] || ''
    const newSrc = (files[i] && files[i].src) || ''

    if (newSrc === oldSrc) continue
    if (!isAnnotationSrcChange(newSrc, oldSrc)) return false

    changedCount++
  }

  return changedCount === 1
}

function isAnnotationSrcChange (newSrc, oldSrc) {
  if (!newSrc || !oldSrc) return false
  let newSrcWithoutHttp = newSrc.replace(/^https?:\/\//, '')
  let oldSrcWithoutHttp = oldSrc.replace(/^https?:\/\//, '')
  const annotationPrefix = `${oldSrcWithoutHttp}.annotation.`
  return newSrcWithoutHttp.indexOf(annotationPrefix) === 0
}



// WEBPACK FOOTER //
// ./src/views/question-review/packages/AnswerFileList/annotationFileChange.js